import { useRouter } from "next/router";
import type { VideoSeasonType } from "~/components/blocks/product/type-guard";
import { PATHS } from "~/const/paths";
import { usePurchaseModalActions } from "~/hooks/use-purchase-modal-actions";
import { goToWelcomePage } from "~/util/go-to-welcome-page";

type Args = {
  episodeContentId: string;
  ppvProducts: VideoSeasonType["episodes"]["edges"][number]["node"]["ppvProducts"];
  svodProduct: VideoSeasonType["episodes"]["edges"][number]["node"]["svodProduct"];
  isStreamable: boolean;
  season: string;
};

export const useOnClickForNoResume = (args: Args) => {
  const { episodeContentId, ppvProducts, svodProduct, isStreamable, season } = args;

  const { push } = useRouter();
  const { pushWithQueriesPurchaseModal } = usePurchaseModalActions();

  const onClickForNoResume = () => {
    if (isStreamable) {
      void push({
        pathname: PATHS.VOD_PLAYER,
        query: {
          season,
          content: episodeContentId,
        },
      });
      return;
    }

    // PPV商品の場合は購入モーダルを開く
    if (ppvProducts.length > 0) {
      pushWithQueriesPurchaseModal(episodeContentId);
      return;
    }

    // SVOD商品の場合はウェルカムページに遷移する
    if (svodProduct !== undefined && svodProduct !== null) {
      goToWelcomePage();
      return;
    }
    return;
  };

  return { onClickForNoResume };
};
